import axios from "axios";

export default {

    namespaced: true,

    state: {

        groups: [],
        groupmembers: [],
        group: {}

    },

    getters: {

        groups(state) {
            return state.groups;
        },
        groupmembers(state) {
            return state.groupmembers;
        },
        group(state) {
            return state.group;
        }

    },

    mutations: {

        SET_GROUPS(state, groups) {
            return state.groups = groups
        },

        SET_GROUPMEMBERS(state, groupmembers) {
            return state.groupmembers = groupmembers
        },

        SET_GROUP(state, group) {
            return state.group = group
        }

    },

    actions: {

        async fetchGroups({ commit }, params) {

            await axios.get('/api/v1/groups', { params: params })
                .then(res => {
                    commit('SET_GROUPS', res.data);
                }).catch(err => {
                    return Promise.reject(err);
                })

        },

        async fetchGroupMembers({ commit }, group_id, params) {
            console.log("grp id", group_id, params);

            await axios.get(`/api/v1/groups/${group_id}/members`, { params: params })
                .then(res => {
                    commit('SET_GROUPMEMBERS', res.data);
                }).catch(err => {
                    return Promise.reject(err);
                })

        },

        async fetchGroup({ commit }, group_id) {

            await axios.get(`/api/v1/groups/${group_id}`)
                .then(res => {
                    // console.log("fetchGroup store == ", res);
                    if (res.statusText === 'OK') {
                        commit('SET_GROUP', res.data.data);
                    }
                }).catch(err => {
                    return Promise.reject(err);
                })

        },

        async createGroup({ commit, dispatch }, group) {

            await axios.post('/api/v1/groups', group)
                .then(res => {
                    if (res.statusText === 'OK') {
                        dispatch('fetchGroups');
                    }
                }).catch(err => {
                    return Promise.reject(err);
                })

        },

        async updateGroup({ commit, dispatch }, group) {

            await axios("/api/v1/groups/" + group.customer_id, {
                method: "patch",
                data: group,
            }).then(res => {
                if (res.statusText === 'OK') {
                    dispatch('fetchGroups');
                }
            }).catch(err => {
                return Promise.reject(err);
            })

        },

        async deleteGroup({ commit }, dispatch, group_id) {

            await axios.delete(`/api/v1/groups/${group_id}`)
            .then(res => {
                if (res.statusText === 'OK') {
                    dispatch('fetchGroups');
                }
            }).catch(err => {
                return Promise.reject(err);
            });

        }

    }

}
